import 'css-chunksrc/client/pages/documentsPage/documentsPage/preview/styles.scss';export default {
  "preview": "_preview_1yj09_1",
  "loader": "_loader_1yj09_12"
};